import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { HttpBaseService } from "../services/httpBase.service";
import api from "../api";
import { GetStore, GetSessionStore } from "../services/comment";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-news-detail",
  templateUrl: "./news-detail.component.html",
  styleUrls: ["./news-detail.component.less"]
})
export class NewsDetailComponent implements OnInit {
  id: string;
  data = {};
  certificate = JSON.parse(GetSessionStore("successLoginInfo")).certificate;
  constructor(
    private route: ActivatedRoute,
    private http: HttpBaseService,
    private sanitizer: DomSanitizer
  ) {
    this.id = this.route.params["value"].id;
  }
  // newsFindById
  ngOnInit() {
    this.http
      .post(api.newsFindById, {
        params: JSON.stringify({ id: this.id })
      })
      .subscribe(res => {
        this.data = res.data;
        this.data["articleContent"] = this.sanitizer.bypassSecurityTrustHtml(
          this.data["articleContent"]
        );
        //
      });
  }
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/news-detail/news-detail.component.ts